import { z } from "zod";
export const ProductCodeSchema = z.enum([
    "free",
    "team",
    "company",
    "enterprise",
    "pro",
]);
export const ProductCode = ProductCodeSchema.enum;
